import { defaultConfirmationPaneLocalizedTexts } from "../../confirmationpanestateful/common/defaultProps/defaultConfirmationPaneLocalizedTexts";
export const initConfirmationPropsComposer = props => {
  var _props$confirmationPa, _props$footerProps, _props$footerProps$co, _props$footerProps2, _props$footerProps2$c, _props$confirmationPa2;
  const confirmationPanelocalizedTexts = {
    ...defaultConfirmationPaneLocalizedTexts,
    ...(props === null || props === void 0 ? void 0 : (_props$confirmationPa = props.confirmationPaneProps) === null || _props$confirmationPa === void 0 ? void 0 : _props$confirmationPa.confirmationPaneLocalizedTexts)
  };
  let confirmationPaneInputs;
  const emailTranscriptDisabled = ((_props$footerProps = props.footerProps) === null || _props$footerProps === void 0 ? void 0 : (_props$footerProps$co = _props$footerProps.controlProps) === null || _props$footerProps$co === void 0 ? void 0 : _props$footerProps$co.hideEmailTranscriptButton) ?? false;
  const downloadTranscriptDisabled = ((_props$footerProps2 = props.footerProps) === null || _props$footerProps2 === void 0 ? void 0 : (_props$footerProps2$c = _props$footerProps2.controlProps) === null || _props$footerProps2$c === void 0 ? void 0 : _props$footerProps2$c.hideDownloadTranscriptButton) ?? false;
  if (!emailTranscriptDisabled && !downloadTranscriptDisabled) {
    confirmationPaneInputs = {
      title: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_TITLE_FOR_EMAIL_AND_DOWNLOAD_TRANSCRIPT_ENABLED,
      description: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_DESCRIPTION_FOR_EMAIL_AND_DOWNLOAD_TRANSCRIPT_ENABLED
    };
  } else if (emailTranscriptDisabled && !downloadTranscriptDisabled) {
    confirmationPaneInputs = {
      title: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_TITLE_FOR_DOWNLOAD_TRANSCRIPT_ENABLED,
      description: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_DESCRIPTION_FOR_DOWNLOAD_TRANSCRIPT_ENABLED
    };
  } else if (!emailTranscriptDisabled && downloadTranscriptDisabled) {
    confirmationPaneInputs = {
      title: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_TITLE_FOR_EMAIL_TRANSCRIPT_ENABLED,
      description: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_DESCRIPTION_FOR_EMAIL_TRANSCRIPT_ENABLED
    };
  } else {
    confirmationPaneInputs = {
      title: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_TITLE_DEFAULT,
      description: confirmationPanelocalizedTexts.CLOSE_CONFIRMATION_DIALOG_DESCRIPTION_DEFAULT
    };
  }
  const confirmationPaneProps = {
    ...props.confirmationPaneProps,
    controlProps: {
      titleText: confirmationPaneInputs.title,
      subtitleText: confirmationPaneInputs.description,
      ...((_props$confirmationPa2 = props.confirmationPaneProps) === null || _props$confirmationPa2 === void 0 ? void 0 : _props$confirmationPa2.controlProps)
    }
  };
  return confirmationPaneProps;
};